import App from "./app";
import initializeSvelteApp from "common/initializeSvelteApp";

initializeSvelteApp({
  component: App,
  target: ".tc-territory-language-dropdown",
  props: element => {
    return {
      showTerritory: JSON.parse(element.getAttribute("data-show-territory")),
      baseUrl: element.getAttribute("data-base-url"),
      url: element.getAttribute("data-url"),
      territory: element.getAttribute("data-territory"),
      territories: JSON.parse(element.getAttribute("data-territories")),
      language: element.getAttribute("data-language"),
      languages: JSON.parse(element.getAttribute("data-languages")),
      strings: JSON.parse(element.getAttribute("data-strings")),
    };
  },
});
